<template>
  <v-card class="mx-auto" max-width="700px">
    <v-card-title class="px-4">
      <span class="headline">Doble factor de autenticación</span>
    </v-card-title>
    <v-card-text class="py-0 px-4">
      <p>Introduce el código de 6 dígitos generado por Google Authenticator</p>
      <v-row class="pb-4 pt-2 pl-4">
        <v-icon>fas fa-user-shield</v-icon>
        <p class="my-auto ml-2 body-1">{{ email }}</p>
      </v-row>
      <v-text-field
        v-model="token"
        label="Código de Autenticación"
        placeholder="123456"
        maxlength="6"
        type="text"
        outlined
        dense
        required
        class="mt-4"
        :rules="rules"
      />
    </v-card-text>
    <v-card-actions class="px-4 pb-4 pt-0 d-flex justify-space-between">
      <v-btn @click="closeDialog" class="bt-exit">{{
        $tc("commons.cancel")
      }}</v-btn>
      <v-btn @click="verifyToken" class="bt-acept">{{
        $tc("commons.validate")
      }}</v-btn>
    </v-card-actions>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>

<script>
import Snackbar from "../Complement/Snackbar.vue";
import login from "../../store/login/login";
import permissions from "../mixins/permissions";
import insurable from "../../store/common/insurable";

export default {
  mixins: [permissions],
  components: { Snackbar },
  data() {
    return {
      email: localStorage.getItem("email"),
      token: "",
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
        (v) =>
          /^\d{6}$/.test(v) || this.$tc("editRegistrations.invalidTokenLength"),
      ],
      alert: false,
      textAlert: "",
      color: "",
    };
  },
  computed: {
    pageInit() {
      return insurable.state.initPage;
    },
    insurable() {
      return insurable.state.insurable;
    },
  },
  mounted() {
    if (localStorage.getItem("dialogTwoFA")) {
      window.addEventListener("keydown", this.handleKeyDown);
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    closeDialog() {
      this.reset();
      this.token = "";
    },
    verifyToken() {
      if (this.token.length === 6 && !isNaN(this.token)) {
        this.save(this.token);
      }
    },
    reset() {
      localStorage.removeItem("dialogTwoFA");
      localStorage.removeItem("empId");
      localStorage.removeItem("auditRegis");
      localStorage.removeItem("token");
      localStorage.removeItem("operId");
      localStorage.removeItem("rolId");
      localStorage.removeItem("name");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("asegurables");
      localStorage.removeItem("init");
      localStorage.removeItem("active2fa");
      this.$router.push({ path: "/signin" });
    },
    async save(token) {
      const twoFactor = await login.dispatch("verifyTwoFactor", token);
      if (twoFactor.verified === true) {
        localStorage.removeItem("dialogTwoFA");
        window.removeEventListener("keydown", this.handleKeyDown);
        this.searchIniTPage();
      } else {
        this.showAlert("El token de seguridad no coincide", "#ff8d58");
      }
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    searchIniTPage() {
      const role = parseInt(localStorage.getItem("init"), 10);
      let page = this.pageInit.find((item) => item.id == role);
      if (this.can(page?.code)) {
        this.$router.push({ path: page.name });
      } else {
        this.$router.push({ path: "Dashboard" });
      }
    },
  },
};
</script>

<style scoped>
.headline {
  font-size: 20px;
  font-weight: bold;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
